<template>
     <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" >
         <div class="row align-center">
            <div class="col-2 col-sm-1 py-0 pl-5  pl-md-5 text-center rounded">
                <img :src="`${require('@/assets/Sedes-CDA.png')}`" class="img-dialog-description">
            </div>
            <div class="col-10 col-sm-11 pt-0 pl-10 pl-md-0 orange--text">
                <div class="font-weight-black orange--text col pt-1 font-title text-md-h4 text-sm-h4 text-h5" style="line-height:1"><i>CENTRO DE APLICACIONES</i></div>
                <h1 class='graylight--text col font-title' style="line-height:0">Sede Quito</h1>
            </div>
        </div>
        <v-col cols="12" class="grayblack--text font-text"  style='display: inline-block;'>
            En virtud de asegurar su comodidad, lo invitamos a concurrir a nuestros centros de aplicaciones,
            <br />
            donde podrá recibir la administración de terapias biológicas, hierros, antibióticos, vitaminas e hidrataciones que lo requieran. 
            <br />
            o bien la medicina que requiera.
        </v-col>
        <v-col cols="12"  class="grayblack--text">
            <b>Av. Mariana de Jesús Oe7-02 y Nuño de Valderrama, Quito, Ecuador</b>
            <br />
            <i>(Edificio Citimed, Local 111, planta baja, pasando el patio de comidas)</i>

            <p class="pt-5">Abierto de lunes a viernes de 9 a 18 hs y sábados de 9 a 13 hs.</p>
        </v-col>
        <v-col cols="12">
            <v-responsive >
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15959.191584575367!2d-78.502217!3d-0.1833301!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1f5599e1c66c81f!2sInnofarm%20-%20Salud%2C%20bienestar%20y%20compromiso!5e0!3m2!1ses!2sec!4v1616426879416!5m2!1ses!2sec" 
                    width="800" 
                    height="300" 
                    style="border:0;border-radius: 10px;" 
                    allowfullscreen="" 
                    loading="lazy"
                >
                </iframe>
            </v-responsive>
        </v-col>
  </div>
</template>

<script>
export default {
    name: 'AplicationsCenterUioComponent',
    data:()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Sedes',url:'/sedes'},
            {name:'Centro de aplicaciones',url:'/sedes/centro-aplicaciones-quito'}
        ],
    }),
    created(){
        this.$emit('newBreadcrumbs',this.breadcrumbs)
    }
}
</script>

<style>
   .v-application .text-md-h4, .v-application .text-md-h6{
        font-family: Asap!important
    }
</style>